import React, { useRef, useState, useEffect } from 'react';
import SearchIcon from '../../assets/images/Search.png'
import ClearIcon from '../../assets/images/ClearIcon.png'
import GoBtnIcon from '../../assets/images/GoBtn.png'
import CloseIcon from '../../assets/images/close.png';
import GraySearchIcon from '../../assets/images/graySearchIcon.png';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { appTheme } from '../../helpers/utils/Utils';

const SearchInput = ({
  placeholderText = "Search...",
  isEnabled,
  handleSearchClick,
  hideTootipGotIt,
  isInputVisible,
  isTooltipVisible,
  onInputChange,
  handleClear,
  showCloseIcon,
  handleArrowClick,
  isTooltipVisibleForSaving,
  selectedTab,
  labelsShow,
  hideTootipGotItForSaving,
  searchInputId = "search-input",
}) => {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState('');
  const { t } = useTranslation();
  const SearchFiltervalue = useSelector(state => state.SearchFiltervalue);
  const previousTabRef = useRef();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);


  const appThemeData  = appTheme(kudzuPlusTrue)

  const dispatch = useDispatch()


  useEffect(() => {
    if (SearchFiltervalue) {
      setInputValue(SearchFiltervalue);
      onInputChange(SearchFiltervalue);
    }
  }, [SearchFiltervalue]);


  useEffect(() => {
    if (isInputVisible) {
      inputRef.current?.focus();
    }
  }, [isInputVisible]);

  const handleSearchChange = (e) => {
    dispatch({ type: 'CLOSE_ICON_FROM_STORE', payload: { closeIconFromStore: false } });
    const newValue = e.target.value;
    setInputValue(newValue);
    onInputChange(newValue); // Call the parent handler with the new value
  };

  useEffect(() => {
    if (SearchFiltervalue) {
      handleSearchClick()
    }
  }, [])

  

  useEffect(() => {
    if (previousTabRef.current && previousTabRef.current !== selectedTab) {
      global.searchValueFromGlobal = '';
      setInputValue('');
    }
    previousTabRef.current = selectedTab;
  }, [selectedTab]);


  const CloseIconClick = () => {
    global.searchValueFromGlobal = '';
    setInputValue('');
    onInputChange('');
  }



  console.log(SearchFiltervalue, "SearchFiltervalue jdeseara")


  return (


    <search className="relative flex items-center">
      {/* Search Icon */}
      {!isInputVisible && (
        <button
          type="button"
          onClick={isEnabled ? handleSearchClick : null}
          className={`${isEnabled ? 'text-[var(--btn-clr-cards)] cursor-pointer ' : 'text-[var(--btn-clr-cards-tabs-disable)]  cursor-not-allowed'} flex justify-between ml-auto space-x-1 lg:text-[18px] md:text-[18px] sm:text-[11px] text-[14px] font-[600] sm:font-[700] items-center`}
          disabled={!isEnabled}
        >
          <img
            src={isEnabled ? appThemeData.searchIcon : appThemeData.greysearchIcon}
            alt=""
            className={`lg:w-[17px] lg:h-[17px] md:w-[11px] md:h-[11px] mr-[6px] ${isEnabled ? '' : 'opacity-50'}`}
            aria-hidden="true"
          />
          <span className="hidden ml-[6px] md:block">{t('SearchBtn')}</span>
        </button>
      )}

      {/* Input Field */}
      {isInputVisible && (
        <div className={` ${labelsShow ? '':'mr-4'} relative`}>
          <label htmlFor={searchInputId} className="sr-only">
            {placeholderText}
          </label>
          <input
            type="search"
            id={searchInputId}
            ref={inputRef}
            value={inputValue}
            onChange={handleSearchChange}
            className="transition-all duration-400 bg-[var(--kudzuplus-primary-bg-search)] w-[100%] ease-in-out px-8 md:py-2 py-1 font-[18px] placeholder-[var(--text-clr-transactions)] placeholder:opacity-50 placeholder:font-semibold text-[var(--text-clr-transactions)] border-[2.5px] border-[var(--modal-text-highlight)] rounded-[59.524px] focus:border-[--modal-text-highlight] focus:outline-none focus:ring-0.5 focus:ring-[--modal-text-highlight]"
            placeholder={placeholderText}
            aria-describedby={isTooltipVisible ? `${searchInputId}-tooltip` : isTooltipVisibleForSaving ? `${searchInputId}-tooltip-saving` : undefined}
          />
          {isTooltipVisible && (
            <div 
              id={`${searchInputId}-tooltip`}
              role="tooltip"
              className="mt-6 font-hanken-grotesk max-w-[132px] leading-4 font-bold absolute top-full left-0  p-[16px] bg-[#2965FB] text-white text-[12px] rounded-xl shadow-lg  z-10"
            >
              <div className="tooltip-arrow"></div>
              {t('transactionSearchBoxMessageTip')}
              <div className='flex justify-end pt-1'>
                <button type="button" className="underline cursor-pointer pt-2 pb-0" onClick={hideTootipGotIt}>{t("GotIt")}</button>
              </div>
            </div>
          )}

          {isTooltipVisibleForSaving && (
            <div 
              id={`${searchInputId}-tooltip-saving`}
              role="tooltip"
              className="mt-6 font-hanken-grotesk max-w-[132px] leading-4 font-bold absolute top-full left-0  p-[16px] bg-[#2965FB] text-white text-[12px] rounded-xl shadow-lg  z-10"
            >
              <div className="tooltip-arrow"></div>
              {t('transactionSearchBoxMessageTip')}
              <div className='flex justify-end pt-1'>
                <button type="button" className="underline cursor-pointer pt-2 pb-0" onClick={hideTootipGotItForSaving}>{t("GotIt")}</button>
              </div>
            </div>
          )}
          <img src={appThemeData.searchIcon} className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" alt="" aria-hidden="true" />
          {inputValue.length === 0 && (
            <button
              type="button"
              id={`${searchInputId}-clear-btn`}
              onClick={handleClear}
              className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
              aria-label={t('clear_search_alt')}
              aria-controls={searchInputId}
            >
              <img src={appThemeData.clearIcon} className="w-4 h-4 text-gray-400" alt="" aria-hidden="true" />
            </button>
          )}
          {inputValue.length > 0  && !showCloseIcon && (
            <button
              type="button"
              id={`${searchInputId}-submit-btn`}
              onClick={handleArrowClick}
              className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
              aria-label={t('submit_search_alt')}
              aria-controls={searchInputId}
            >
              <img src={appThemeData.goBtnIcon} className="w-4 h-4 text-gray-400" alt="" aria-hidden="true" />
            </button>
          )}
          {inputValue && showCloseIcon && (
            <button
              type="button"
              id={`${searchInputId}-close-btn`}
              onClick={CloseIconClick}
              className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
              aria-label={t('closeSearch')}
              aria-controls={searchInputId}
            >
              <img src={appThemeData.searchCloseIcon} className="w-4 h-4 text-gray-400" alt="" aria-hidden="true" />
            </button>
          )}
        </div>
      )}

    </search>
  );
};
export default SearchInput;
